var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.companyName) +
              " ist an einem Ersatztermin interessiert. Bitte teile uns mit ob du auch noch\n\t\tinteressiert bist"
          )
        ])
      ]),
      _vm._v(" "),
      _c("RadioGroup", {
        attrs: { options: _vm.followUpOptions, stacked: "" },
        model: {
          value: _vm.followUp,
          callback: function($$v) {
            _vm.followUp = $$v
          },
          expression: "followUp"
        }
      }),
      _vm._v(" "),
      _vm.followUpInterested
        ? _c("JonInfo", {
            staticClass: "mt-3",
            scopedSlots: _vm._u(
              [
                {
                  key: "message",
                  fn: function() {
                    return [
                      _c("b", [_vm._v(_vm._s(_vm.companyName))]),
                      _vm._v(
                        " wird informiert dass du an einem Ersatztermin interessiert bist.\n\t\t\tWir informieren dich sobald "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.companyName))]),
                      _vm._v(" neue Terminvorschläge für dich hat.\n\t\t")
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3642388828
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.followUpSendOff
        ? _c("ApplicantSendOff", {
            staticClass: "mt-3",
            attrs: {
              customer: _vm.message.customer,
              "is-anonymous": false,
              "with-company-name": false
            },
            model: {
              value: _vm.sendOffData,
              callback: function($$v) {
                _vm.sendOffData = $$v
              },
              expression: "sendOffData"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 text-right" },
        [
          _c("Button", {
            attrs: {
              text: "Senden",
              icon: "checkmark",
              disabled: !_vm.dataValid || _vm.sendingRequest,
              loading: _vm.sendingRequest
            },
            on: { click: _vm.submit }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }